import clsx from "clsx";
import { useAtom } from "jotai";
import { useCallback, useEffect, useState } from "react";

import { GradientButton } from "../../../shared/components/fkl-gradient-button/fkl-gradient-button.component";
import {
  videoLimitAtom,
  videoLimitFinishedAtom,
} from "../../../shared/components/lander-quiz-media-displayer/media-displayer/media-displayer.state";
import {
  landerCplQuizAtom,
  landerCplQuizQuestionAtom,
  landerCplQuizQuestionIndexAtom,
} from "../../lander-cpl-quiz.state";

export const LanderCplQuizFooter: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useAtom(
    landerCplQuizQuestionIndexAtom
  );
  const [currentQuestion] = useAtom(landerCplQuizQuestionAtom(currentIndex));
  const [landerCplQuiz] = useAtom(landerCplQuizAtom);
  const [footerMessage, setFooterMessage] = useState("");
  const [videoInProgressAlert, setVideoInProgressAlert] = useState(false);
  const [videolimitFinished, setVideolimitFinished] = useAtom(
    videoLimitFinishedAtom
  );
  const [videoLimit] = useAtom(videoLimitAtom);
  const stepsPerQuestion = 1;
  const VALID_OPTINS_FOR_VIDEO_ADS = 2;

  const nextBtnFn = () => {
    const submission = window.theme.Sweepstake.prototype.retrieveSubmission();

    if (!videolimitFinished) {
      setFooterMessage(
        `Please watch ${videoLimit} seconds of the video before answering.`
      );
      setVideoInProgressAlert(true);
    } else if (isQuestionAnswered()) {
      if (currentIndex + 1 < landerCplQuiz.questions.length) {
        setCurrentIndex(currentIndex + stepsPerQuestion);
        setVideolimitFinished(false);
      } else if (
        Number(submission?.data?.submissionCount) >= VALID_OPTINS_FOR_VIDEO_ADS &&
        !window.FKL.skipVideoAdsQuiz
      ) {
        window.theme.LanderCplQuizUtils.handleLanderCplQuizNextSweepStep();
      } else {
        window.theme.LanderCplQuizUtils.handleVideoAdsQuizNextSweepStep();
      }
    }
  };

  const isQuestionAnswered = useCallback(() => {
    return !!currentQuestion.answer;
  }, [currentQuestion.answer]);

  const isQuestionCorrect = useCallback(() => {
    return !!currentQuestion.options.find(
      (option) => option.isSelected && option.isCorrect
    );
  }, [currentQuestion.options]);

  const readFooterMessage = useCallback(() => {
    if (isQuestionAnswered()) {
      setVideoInProgressAlert(false);
      return isQuestionCorrect()
        ? "Correct answer! You get +1 entry"
        : "Incorrect answer; you did not get an extra entry";
    }
    return "";
  }, [isQuestionAnswered, isQuestionCorrect]);

  useEffect(() => {
    setFooterMessage(readFooterMessage);
  }, [readFooterMessage, videolimitFinished]);

  return (
    <div className="lander__cpl__quiz__footer">
      <GradientButton
        grayBackground={!(isQuestionAnswered() && videolimitFinished)}
        onClick={nextBtnFn}
      >
        Next
      </GradientButton>
      <span
        className={clsx(
          "lander__cpl__quiz__footer--message",
          isQuestionAnswered() && isQuestionCorrect() && "black-alert--mesage",
          ((isQuestionAnswered() && !isQuestionCorrect()) ||
            videoInProgressAlert) &&
            "red-alert--message"
        )}
        data-testid="lander__cpl__quiz--footer"
      >
        {footerMessage}
      </span>
    </div>
  );
};
